import React from 'react'
import { Dropdown } from 'primereact/dropdown'

import './CustomDropdown.css'

export default function CustomDropdown({
  optionLabel,
  options,
  value,
  onChange,
  label,
  filterMatchMode = 'contains',
  filter = false,
  disabled = false,
  showLabel = true,
  showClear = false,
  marginTop = 9,
  placeholder = '',
  labelPosition = 'top',
  itemTemplate = null,
  tooltip = undefined,
  appendTo = undefined,
}) {
  return (
    <div className={`CustomDropdown label-position-${labelPosition}`} style={{ marginTop }}>
      {showLabel ? <label className="dropdown-label">{label}</label> : null}
      {itemTemplate ? (
        <Dropdown
          filterMatchMode={filterMatchMode}
          itemTemplate={itemTemplate}
          placeholder={placeholder}
          scrollHeight="100px"
          filter={filter}
          showClear={showClear}
          disabled={disabled}
          value={value}
          optionLabel={optionLabel}
          options={options}
          onChange={e => onChange(e.value)}
          tooltip={tooltip}
          appendTo={appendTo}
        />
      ) : (
        <Dropdown
          filterMatchMode={filterMatchMode}
          placeholder={placeholder}
          scrollHeight="100px"
          filter={filter}
          showClear={showClear}
          disabled={disabled}
          value={value}
          optionLabel={optionLabel}
          options={options}
          onChange={e => onChange(e.value)}
          tooltip={tooltip}
          appendTo={appendTo}
        />
      )}
    </div>
  )
}
